/**
 * Should the 10-slide quick tour open BY ITSELF?
 *
 * The rule lived inline in App.jsx at two separate call sites, and they
 * drifted: the brand-new-user branch learned about phones, the
 * already-onboarded branch never did. So finishing /welcome (which sets
 * onboarding_completed) dropped a student straight onto the universities page
 * with "QUICK TOUR — Welcome to Stratia" over it, on the very screen the
 * journey had just delivered them to (founder mobile test, 2026-07-29).
 *
 * One function, both call sites, so the two answers cannot disagree again.
 */
export function shouldAutoOpenTour({ tourSeen, isPhone, carriedDraft = false }) {
    // Seen once is seen for good.
    if (tourSeen) return false;
    // A phone already gets /welcome as its orientation, and a ten-slide modal
    // over a small screen is the same welcome told twice. The tour is still
    // reachable deliberately; it just never ambushes.
    if (isPhone) return false;
    // Mid-flow: a draft carried from the landing hero is being adopted into
    // the profile right now. Interrupting that reads as losing their work.
    if (carriedDraft) return false;
    return true;
}
